import type { BaseColumnConfig } from './types';

/**
 * Filters rows the caller already holds in full by the grid's search box.
 *
 * The client-side counterpart to the server's `applySearch`, and deliberately
 * the same contract: a case-insensitive substring match, OR-ed across every
 * column. Null and undefined cells never match — "null" is absence, not text.
 */
export function searchRowsBy<TRow>(
  rows: TRow[],
  search: string,
  columns: BaseColumnConfig<TRow>[],
): TRow[] {
  const needle = search.trim().toLowerCase();
  if (!needle) return rows;

  return rows.filter((row) =>
    columns.some((col) => {
      const value = col.accessor(row);
      if (value == null) return false;
      return String(value).toLowerCase().includes(needle);
    }),
  );
}
